import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../Avatar';
import Button from '../Button';
import FontAwesomeIcon from '../Icon';
import { Hidden } from '../Table';
import Tenant from '../Tenant';
import { ITableColumn } from '../Table/types';
import { PropertyManagerRow } from 'src/pages/SharedPageCustomHooks/UseContactsSavePropertiesPage/types';
import { getRoleDisplayLabel } from 'src/common/roleRegistry/roleRegistryHelpers';

const sortByString = (a: string, b: string): number => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a.toLowerCase().localeCompare(b.toLowerCase());
};

interface CreatePropertyDevelopersTableColumnsParams {
  propertyData: any;
  user: any;
  handleSetContactFormData: (contactId: string) => Promise<void>;
  onDeleteContact: (data: any) => void;
  PATHS: any;
  ICONS: any;
  onRequestPhoneCall: (phone: any) => any;
  checkSparkDataAvailable: (propertyData: any, roleName: string) => boolean;
}

export const createPropertyDevelopersTableColumns = ({
  propertyData,
  user,
  handleSetContactFormData,
  onDeleteContact,
  PATHS,
  ICONS,
  onRequestPhoneCall,
  checkSparkDataAvailable,
}: CreatePropertyDevelopersTableColumnsParams): ITableColumn[] => {
  return [
    {
      label: 'Contacts',
      sortable: true,
      accessor: 'firstname',
      minWidth: '25rem',
      cell: (data: PropertyManagerRow) => {
        return (
          <Link
            to={{
              pathname: PATHS.CONTACTS_VIEW.replace(':id', data.id),
              state: {
                navOrigin: {
                  kind: 'property',
                  propertyId: propertyData?.id || propertyData?.propertyId,
                  propertyName:
                    propertyData?.name || propertyData?.propertyName,
                },
              },
            }}
          >
            <Tenant
              headline={`${data.firstname} ${data.lastname}`}
              avatar={
                <Avatar
                  badge={ICONS['Property Developer']}
                  url={data.profileImage}
                />
              }
            />
          </Link>
        );
      },
    },
    {
      xsHide: true,
      sortable: true,
      accessor: 'role',
      label: 'Role',
      cell: (data: PropertyManagerRow) => (
        <div style={{ display: 'flex' }}>
          {getRoleDisplayLabel(data.role)}
          {data.isPrimaryContact === true ? (
            <div
              style={{
                display: 'flex',
                color: '#48C2BF',
                justifyContent: 'center',
                alignItems: 'center',
                paddingLeft: 5,
              }}
            >
              <FontAwesomeIcon glyph="sun" weight="regular" size="small" />
            </div>
          ) : (
            <div />
          )}
        </div>
      ),
    },
    {
      label: 'Phone',
      accessor: 'phone',
      sortable: true,
      cell: (data: PropertyManagerRow) => onRequestPhoneCall(data.phone),
    },
    {
      xsHide: true,
      label: 'Email',
      sortable: true,
      accessor: 'email',
      minWidth: '26rem',
    },
    {
      xsHide: true,
      label: 'Last login',
      accessor: 'lastLoggedOn',
      sortable: true,
      cell: (data: PropertyManagerRow) => data.lastLoggedOnFormatted,
    },
    {
      xsHide: true,
      sortable: true,
      label: 'Status',
      width: '8rem',
      accessor: 'status',
      sortingAlgorithm: sortByString,
      cell: (data: PropertyManagerRow) => (
        <div>
          <div title={data.status}>{data.status}</div>
        </div>
      ),
    },
    {
      cell: (data: PropertyManagerRow) => (
        <Hidden>
          {checkSparkDataAvailable(
            propertyData,
            user.roles[0].role.name
          ) ? null : (
            <Button
              color="semantic"
              label={<FontAwesomeIcon glyph="pencil" weight="light" />}
              onClick={() => handleSetContactFormData(data.id)}
            />
          )}
          {user.roles[0].role.name === 'Admin' ||
          user.roles[0].role.name === 'Super Admin' ||
          user.roles[0].role.name === 'Property Developer' ? (
            <Button
              color="semantic"
              onClick={(e: any) =>
                data.isPrimaryContact === false
                  ? window.confirm(
                      `Are you sure you want to remove ${data.firstname} ${data.lastname} from this project?`
                    ) && onDeleteContact(data)
                  : alert(
                      'Please select other property developer as Primary property developer before deleting this property developer'
                    )
              }
              label={<FontAwesomeIcon glyph="trash" weight="light" />}
            />
          ) : null}
        </Hidden>
      ),
    },
  ];
};
